import {observable, asFlat} from 'mobx';
import portalTemplates from '../module_biz/portal/templates/portalTemplates';


export default {
  portalTemplates
};
